import { selectTextInElement } from '@/functions/dom';

/**
 * Highlight (select) the text in an input element when it is clicked/focused,
 * so that you can start typing and replace the text that's already there.
 */
export const selectOnFocus = {
    /**
     * @param {HTMLInputElement} el
     */
    mounted(el) {
        el.addEventListener('focus', () => selectTextInElement(el));
        el.addEventListener('click', () => selectTextInElement(el));
    },
};
